// Scope guard
( function() {

  var $adPreviewDiv = $j( "#ad_preview_div" );
  var previewList = tryParseJSON( $adPreviewDiv.attr( "data-file-list" ) );

  function showPreview( previewObj, currentIndex ) {
    $adPreviewDiv.empty();
    if ( !previewObj ) {
      $adPreviewDiv.append( "<h2 class='scs_gallery_noImg'>No Preview Available</h2>" );
      return;
    }

    var type = previewObj.mimeType;
    var commitHash = $adPreviewDiv.attr( "data-commit-hash" );
    var url;

    if ( type.match("image/.*|application/pdf") ) {
      url = getAdFilePreviewUrl( $adPreviewDiv.attr( "data-ad-id" ),
                                 encodeURIComponent(previewObj.fileName), commitHash );
      var $img = $j( '<img class="scs_gallery_Img">' );
      $img.attr( "src", url  );
      $img.attr( "alt", previewObj.fileName + " Preview" );
      $img.attr( "type", type );
      $adPreviewDiv.append( $img );
    } else if ( type.match("text/*") ) {
      if ( type.match( "text/html" ) ) {
        url = getAdFileRawUrl( $adPreviewDiv.attr( "data-ad-id" ),
                               encodeURIComponent(previewObj.fileName), commitHash );
      }
      var $iframeWrapper = $j( '<div class="iframe-container">' );
      $iframeWrapper.height( "450px" );
      var $iframe = $j( "<iframe>", {
        "src": url,
        "sandbox": "allow-same-origin allow-scripts",
        "security": "restricted"
      } );
      $iframe.on( "load", function() {
        $iframeWrapper.height( $iframe[0].contentWindow.document.body.offsetHeight + "px" );
      } );
      $adPreviewDiv.append( $iframeWrapper.append( $iframe ) );
    } else {
      $adPreviewDiv.append( "<h2 class='scs_gallery_noImg'>No Preview Available for " +
                            previewObj.fileName + "</h2>" );
    }

    $adPreviewDiv.append( "<h3><i class='fa fa-file scs_gray'></i> " +
                          "File (" + ( currentIndex + 1 ) + "/" +
                          previewList.fileList.length + "): " +
                          "<span style='font-weight:normal;'>" +
                          previewObj.fileName + "</span></h3>" );
  }

  function showNextPreview(backwards) {
    /* Displays the next viewable ad file.
       If backwards is true it goes through the list in reverse. */
    backwards = isUndefinedOrNull( backwards ) ? false : backwards;
    var currentIndex = parseInt( $adPreviewDiv.attr( "data-file-list-index" ), 0 );

    currentIndex += backwards ? -1 : 1;
    if (currentIndex < 0) {
      currentIndex = previewList.fileList.length - 1;
    } else if (currentIndex >= previewList.fileList.length) {
      currentIndex = 0;
    }

    $adPreviewDiv.attr( "data-file-list-index", currentIndex );
    showPreview( previewList.fileList[currentIndex], currentIndex );
  }

  function tryParseJSON( inJSON ) {
    try {
      let newJSON = JSON.parse( inJSON );
      return newJSON.length === 0 ? JSON.parse( '{"fileList":[]}' ) : newJSON ;
    } catch( ex ) {
      console.log( ex );
      console.log( inJSON );
      return JSON.parse( '{"fileList":[]}' ); // Give an empty file list if parse fails
    }
  }

  // onload
  $j( function() {
    if ( previewList.fileList.length > 1 ) {
      $adPreviewDiv.addClass( "gallery-image" );
      $adPreviewDiv.click( function( e ) {
        var mouseX = e.originalEvent.x,
        $img = $j(e.currentTarget),
        leftBound = $img.offset().left,
        rightBound = leftBound + $img.width(),
        middle = (leftBound + rightBound) / 2;
        // Go backwards if we clicked on the left side
        showNextPreview( mouseX < middle );
      });
    }
    showPreview( previewList.fileList[0], 0 );
  } );

})();
